export const config = {
  SCROLL_THRESHOLD: 50,
  DEBOUNCE_DELAY: 150,
  MAX_COMMENT_LENGTH: 250,
  CHILD_TABLE_HEIGHT: 400,
  ITEMS_PER_SCROLL: 20,
  ITEMS_PER_PAGE: 10,
  API_PATH: '/integrations/service-dashboard',
  ADMIN_SCOPE: ['admin/common'],
  FRONTLINE_SCOPE: ['frontline/common'],
  IS_COMMENT_REQUIRED: ['Resolved', 'Support Required'],
}

export const MESSAGE = {
  SUPPORT_REQUEST_SUCCESS_TOAST: 'Your support request has been submitted successfully.',
  ADD_COMMENT_BEFORE_RECALL: 'Please add a comment before recalling this request.',
  COMMENT_IS_REQUIRED: 'A comment is required.',
  PLEASE_SELECT_ANY_OPTION: 'Please select at least one option.',
  PLEASE_GIVE_SOME_VALUE_FOR_SEARCH: 'Please enter a value to search.',
  DOWNLOAD_EXCEL_FILE: 'Preparing your Excel file...',
  DOWNLOAD_EXCEL_FILE_SUCCESS: 'Your Excel file has been downloaded successfully.',
  DOWNLOAD_EXCEL_FILE_FAILED: 'Failed to download the Excel file.',
  RESOLVE: 'Resolve',
  RECALL: 'Recall',
  ERROR: 'Error',
  RESOLVED: 'Resolved',
  SUPPORT_REQUIRED: 'Support Required',
  SUCCESS: 'Success',
  FAILED: 'Failed',
  SKIPPED: 'Skipped',
  RESOLVE_CONFIRMATION: 'Confirm Resolve',
  RECALL_CONFIRMATION: 'Confirm Recall',
  RESOLVED_CONFIRMATION_MESSAGE: 'Are you sure you want to mark this request as resolved?',
  RECALL_CONFIRMATION_MESSAGE: 'Are you sure you want to recall this request?',
  SUPPORT_REQUIRED_MESSAGE: 'This request will be marked as Support Required.',
  ADD_SUPPORT_REQUIRED: 'Submit',
  BUTTON_TEXT: 'Yes',

  INCOMING_EVENT: 'Incoming Events',
  FSM_CASES: 'FSM Cases',
  CDC_CASES: 'CDC Cases',
  TECHNICAL_FAILURE: 'Technical Failure',
}

export const columnConfig: Record<string, string> = {
  purchase_order_number: 'Customer Work Order Number',
  location_reference_number: 'Location Reference Number',
  equipment_reference_number: 'Equipment Reference Number',
  fsm_case_number: 'FSM Case Number',
  csd_case_number: 'CSD Case Number',
  fsm_work_order_number: 'FSM Work Order Number',
}

export const INITIAL_SCROLL_STATE: { page: number; loading: boolean } = {
  page: 1,
  loading: false,
}

export type JsonbErrorReason = Record<string, any> | null

export interface DashboardEventRecord {
  event_id: string // UUID
  purchase_order_number: string | null
  location_reference_number: string | null
  equipment_reference_number: string | null
  org_id: string | null
  equipment_type: string | null
  category: string | null
  event_type: string | null
  asset_type: string | null
  metadata: Record<string, any> | null

  cpe_status: string | null
  cpe_received_at: Date | null
  cpe_error_reason: JsonbErrorReason

  kens_identified_status: string
  kens_identified_received_at: Date | null
  kens: string[] | null
  kone_equipment_type: string | null
  kens_identified_error_reason: JsonbErrorReason

  category_matched_status: string
  category_matched_received_at: Date | null
  kone_category: string | null
  matched_rule: string | null
  category_matched_error_reason: JsonbErrorReason

  action_created_status: string
  action_created_received_at: Date | null
  case_number: string | null
  work_order_number: string | null
  case_type: string | null
  ken: string | null
  action_type: string | null
  action_details: Record<string, any> | null
  action_created_error_reason: JsonbErrorReason

  dashboard_status: 'Success' | 'Failed'

  country: string | null
  organization_name: string
  customer_name: string
  customer_portal_name: string
  total_record: string | number
}

export type Filters = {
  log_status: string
  request_type?: string
  type?: any
  search_term?: string
  start?: number
  limit?: number
  orderBy?: string
  range?:
  | {
    duration: 'today' | 'week' | 'month' | 'custom'
    from?: string
    to?: string
  }
  | Record<string, never>
  org_ids?: string[]
  integration_partner?: string[]
  countries?: string[]
  customer_name?: string[]
  kone_category?: string[]
}

export type getFilters = {
  org_ids?: string[]
  type?: 'customer_portal_name' | 'customer_name' | 'kone_category' | undefined
}

export const formatSection = (section: string): string =>
  section.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase())

// Utility function to flatten metadata
export const flattenObject = (ob: any) => {
  const toReturn: any = {}
  for (const i in ob) {
    if (!Object.prototype.hasOwnProperty.call(ob, i)) {
      continue
    }
    if (typeof ob[i] == 'object' && ob[i] !== null && !Array.isArray(ob[i])) {
      const flatObject = flattenObject(ob[i])
      for (const x in flatObject) {
        if (!Object.prototype.hasOwnProperty.call(flatObject, x)) {
          continue
        }
        toReturn[i + '.' + x] = flatObject[x]
      }
    } else {
      toReturn[i] = ob[i]
    }
  }
  return toReturn
}
